import React, { useEffect, useState } from 'react';
import Utils from '../utils';
import Navigation from '../utils/Navigation';

const { Session, Util } = Utils;

const BillingStatus = ({ modalTitleCallback = () => {} }) => {
	const [modalContent, setModalContent] = useState('');
	const { subscriptionStatus } = Session.getAccountInfo();

	const passToIframe = parsedContent => {
		if (window.self !== window.parent) {
			// set the modal title to the parent window object if this is opened in an iframe
			const { AllowedTargetOrigin } = Session.getSettings();

			Util.postMessage(
				{
					billingStatus: parsedContent.status,
					billingStatusModalTitle: parsedContent.title,
				},
				AllowedTargetOrigin
			);
		}
	};

	const getModalContent = async (status = {}) => {
		const {
			adminHold = false,
			resubmit = false,
			serviceFeesNotPaid = false,
			paymentHold = false,
		} = status;
		let parsedContent = null;

		const url = await Navigation.getNavigationUrl('changePaymentMethod');
		const paymentSettingsUrl =
			await Navigation.getNavigationUrl('paymentSettings');
		const targetBlankProps =
			window.self !== window.parent ? { target: '_blank' } : {};
		const contactNumber = Util.getFraudNumber();

		const ContentWithLink = ({ text }) => (
			<>
				{text.replace('Payment Methods in Account Settings.', '')}{' '}
				<a href={url} {...targetBlankProps}>
					Payment Methods in Account Settings.
				</a>
			</>
		);

		const lockedAndPastDueContent = (
			<>
				Your account has been locked due to unpaid service fees. To continue
				using your account, please go to{' '}
				<a href={paymentSettingsUrl} {...targetBlankProps}>
					Payment Settings
				</a>{' '}
				and update the payment method.
			</>
		);

		const content = {
			cannotPrintOrPurchase: {
				// prints, purchases are blocked
				status: 'cannotPrintOrPurchase',
				title: 'Account Temporarily Locked',
				text: 'Due to the current status of your account, you cannot print or purchase funds. Please call Customer Care at {contactNumber} for assistance.',
			},
			outstandingServiceFee: {
				// purchase will be blocked only if same payment method that is failing for subscription is used
				status: 'outstandingServiceFee',
				title: 'Update Payment Method',
				text: (
					<ContentWithLink text="Our records show an outstanding service fee on your account due to an expired payment method. To maintain access to your account, update your credit card in the Payment Methods in Account Settings." />
				),
			},
			lockedAccount: {
				// prints, purchases are blocked
				status: 'lockedAccount',
				title: 'Account Temporarily Locked',
				text: lockedAndPastDueContent,
			},
			cannotPurchaseFunds: {
				// purchase is blocked, able to print until the user has account balance
				status: 'cannotPurchaseFunds',
				title: 'Account Temporarily Locked',
				text: 'Due to the current status of your account, you cannot purchase funds. Please call Customer Care at {contactNumber} for assistance.',
			},
			pastDueAmount: {
				// purchase is blocked
				status: 'pastDueAmount',
				title: 'Account Temporarily Locked',
				text: lockedAndPastDueContent,
			},
		};

		// This block of if-else statements is left in place even though this could be grouped because Product sees these as distinct cases.
		if (adminHold && !resubmit && !serviceFeesNotPaid && !paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (adminHold && resubmit && !serviceFeesNotPaid && !paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (adminHold && !resubmit && serviceFeesNotPaid && !paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (adminHold && !resubmit && !serviceFeesNotPaid && paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (adminHold && resubmit && serviceFeesNotPaid && !paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (adminHold && resubmit && !serviceFeesNotPaid && paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (adminHold && !resubmit && serviceFeesNotPaid && paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (adminHold && resubmit && serviceFeesNotPaid && paymentHold) {
			parsedContent = content.cannotPrintOrPurchase;
		} else if (!adminHold && resubmit && !serviceFeesNotPaid && !paymentHold) {
			parsedContent = content.outstandingServiceFee;
		} else if (!adminHold && resubmit && serviceFeesNotPaid && !paymentHold) {
			parsedContent = content.pastDueAmount;
		} else if (!adminHold && resubmit && !serviceFeesNotPaid && paymentHold) {
			parsedContent = content.cannotPurchaseFunds;
		} else if (!adminHold && resubmit && serviceFeesNotPaid && paymentHold) {
			parsedContent = content.lockedAccount;
		} else if (!adminHold && !resubmit && serviceFeesNotPaid && !paymentHold) {
			parsedContent = content.lockedAccount;
		} else if (!adminHold && !resubmit && serviceFeesNotPaid && paymentHold) {
			parsedContent = content.lockedAccount;
		} else if (!adminHold && !resubmit && !serviceFeesNotPaid && paymentHold) {
			parsedContent = content.cannotPurchaseFunds;
		} else {
			parsedContent = null;
		}

		setModalContent(content.lockedAccount.text);
		if (parsedContent) {
			passToIframe(parsedContent);
			modalTitleCallback(parsedContent.title);
			setModalContent(parsedContent.text);
		} else {
			passToIframe({ status: 'okay', title: '' });
		}
	};

	useEffect(() => {
		getModalContent(subscriptionStatus);
	}, []);

	return (
		<div>
			<p>{modalContent}</p>
		</div>
	);
};

export default BillingStatus;
